module.exports = __webpack_public_path__ + "img/notes-medical.165dab94.svg";